// extracted by mini-css-extract-plugin
export var createdDate = "_my-1";
export var divider = "_my-2";
export var headerDivider = "_my-3";
export var messagesCard = "_my-0";
export var messagesContainer = "_my-6";
export var messagesContainerWrapper = "_my-4";
export var showLeftPanelButton = "_my-8";
export var topButtons = "_my-7";
export var withPadding = "_my-5";